<template>
  <el-drawer :visible.sync="show" :title="name" size="80%">
    <div style="width: 100%; height: 100%; padding: 20px; box-sizing: border-box; overflow-y: auto;">
      <template v-for="(field, index) in fieldList">
        <div style="display: flex; font-size: 12px;" :style="{ marginTop: index > 0 ? '20px' : 0 }">
          <template v-for="(item, _index) in field">
            <div style="width: 20%; text-align: center;" :style="{ color: item.type === 'title' ? '#888' : '#333' }">
              <template v-if="['title', 'string'].includes(item.type)">
                {{ item.prop }}
              </template>
              <template v-else-if="item.type === 'image'">
                <el-image :src="item.prop" style="width: 96px; height: 26px; object-fit: cover;" v-if="item.prop"
                  :preview-src-list="[item.prop]"></el-image>
              </template>
            </div>
          </template>
        </div>
      </template>
      <div style="margin-top: 20px;">
        <el-tabs v-model="activeName">
          <el-tab-pane label="访问明细" name="viewRecords">
            <el-table :data="data.viewRecords" border style="width: 100%" size="mini">
              <el-table-column v-for="column in viewRecordColumns" :key="column.prop" v-bind="column"></el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane :label="data.type === 'LaboratoryReport' ? '化验报告' : '煤种报价'" name="contents">
            <el-table :data="list" border style="width: 100%" size="mini" ref="table">
              <el-table-column v-for="column in tableColumns" :key="column.prop" v-bind="column"></el-table-column>
              <el-table-column width="100" label="操作" align="center">
                <template #default="scope">
                  <el-popconfirm :title="`确定删除该条${data.type === 'LaboratoryReport' ? '化验报告' : '煤种报价'}吗？`"
                    @confirm="handleDelete(scope.row)">
                    <template #reference>
                      <el-button size="mini" type="text" style="color: #F56C6C;">删除</el-button>
                    </template>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </el-drawer>
</template>
<script>
export default {
  name: 'Detail',
  data() {
    return {
      show: false,
      name: '',
      data: {},
      list: [],
      activeName: 'viewRecords'
    }
  },
  computed: {
    fieldList() {
      return [
        [
          { prop: '标题', type: 'title' },
          { prop: '副标题', type: 'title' },
          { prop: '类型', type: 'title' },
          { prop: '是否Banner', type: 'title' },
          { prop: '图片', type: 'title' }
        ],
        [
          { prop: this.data.title, type: 'string' },
          { prop: this.data.secondTitle, type: 'string' },
          { prop: this.data.type === 'LaboratoryReport' ? '化验报告' : '煤种报价', type: 'string' },
          { prop: this.data.bannerTopic ? '是' : '否', type: 'string' },
          { prop: this.data.bannerImage, type: 'image' }
        ],
        [
          { prop: '访问次数', type: 'title' },
          { prop: '访问人数', type: 'title' }
        ],
        [
          { prop: this.data.viewCount, type: 'string' },
          { prop: this.data.userCount, type: 'string' }
        ]
      ]
    },
    viewRecordColumns() {
      return [
        { prop: 'createUserName', label: '访问人', width: 180, align: 'center' },
        { prop: 'userPhone', label: '手机号', align: 'center' },
        { prop: 'createTime', label: '创建时间', align: 'center' },
        { prop: 'viewCount', label: '访问次数', align: 'center' }
      ]
    },
    tableColumns() {
      let columns = [
        { prop: 'name', label: '名称', width: 180, align: 'center' },
        { prop: 'deliveryName', label: '商铺', align: 'center' },
        { prop: 'priceType', label: '价格类型', align: 'center' },
        { prop: 'price', label: '价格', align: 'center' }
      ]
      if (this.data.type === 'LaboratoryReport') {
        columns = [
          { prop: 'laboratoryName', label: '化验室', width: 180, align: 'center' },
          { prop: 'coalShopName', label: '煤源', align: 'center' },
          { prop: 'coalProductName', label: '煤种', align: 'center' },
          { prop: 'createTime', label: '报告生成时间', align: 'center' }
        ]
      }
      return columns
    },
  },
  methods: {
    display(event) {
      this.data = event.data
      this.list = []
      this.data.contents.forEach(item => {
        item.data.recordId = item.id
        this.list.push(item.data)
      })
      this.name = event.name
      this.show = true
    },
    handleDelete(event) {
      this.$axios.get('/account/topic/manager/content/remove', { params: { id: event.recordId } }).then(() => {
        this.$message.success({ showClose: true, message: '删除成功' })
        this.list = this.list.filter(item => item.recordId !== event.recordId)
      })
    }
  }
}
</script>